<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="faq-kartu-prakerja">
    <FaqHeader />
    <div class="content">
      <div v-if="getIsLoading" data-testid="faq-detail-shimmer">
        <div class="animate-pulse w-full h-7 bg-gray-20 rounded" />
        <div class="mt-24 animate-pulse w-full h-80 bg-gray-20 rounded" />
      </div>
      <div v-else data-testid="faq-detail-content">
        <BlTextAv variation="heading-28" weight="bold">{{ getFaqDetail.title }}</BlTextAv>
        <p class="mt-24 bl-text bl-text--body-16 c-summary" v-html="formatHtml(getFaqDetail.body)" />
      </div>
      <div class="mt-24">
        <BlTextAv class="bl-text--body-16 mb-12" variation="body-16" weight="bold">Butuh bantuan langsung?</BlTextAv>
        <PrakerjaBukabantuan class="w-full" />
      </div>
    </div>
    <FaqFooter />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import FaqHeader from '../components/FaqHeader/FaqHeader.vue';
import FaqFooter from '../components/FaqFooter/FaqFooter.vue';
import xss from 'xss';
import {BlTextAv} from '@bukalapak/bazaar-mweb-latest';
import PrakerjaBukabantuan from 'shared/components/PrakerjaBukabantuan/PrakerjaBukabantuan.vue';

export default {
  name: 'PrakerjaFaqDetailPage',
  components: {
    FaqHeader,
    FaqFooter,
    BlTextAv,
    PrakerjaBukabantuan,
  },
  computed: {
    ...mapGetters('faqs', ['getFaqDetail', 'getIsLoading']),
    articleId() {
      const slug = this.$route.params.slug;
      const match = slug.match(/\d+$/);
      return match ? match[0] : null;
    },
  },
  mounted() {
    this.$store.dispatch('faqs/fetchFaqDetail', {article_id: this.articleId});
  },
  methods: {
    formatHtml(html) {
      return xss(html);
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: calc(100vh - 220px);
  padding: 16px;
}
</style>

<style lang="scss">
.c-summary {
  img {
    max-width: 100%;
  }
}
</style>
